import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
  clearBasket,
  showModal,
  setShowOnClosePopUp,
} from '../../redux/actions';
import { ReactComponent as Close } from '../../svg/close.svg';

import { notAllSegmentsHaveSeats } from '../../utils/onExitModalPopupValidation';

// Define the shape of the component's own props
interface CloseButtonOwnProps {
  disabled?: boolean;
  isOptIn?: boolean;
}

const mapStateToProps = (state: any) => ({
  variants: state.session?.variants || {},
  basket: state.basket,
  itinerary: state.itinerary,
  passengers: state.passengers?.listOfPassenger || [],
});

const mapDispatchToProps = {
  showModal,
  clearBasket,
  setShowOnClosePopUp,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type CloseButtonProps = CloseButtonOwnProps & PropsFromRedux;

const CloseButton: React.FC<CloseButtonProps> = (props) => {
  const {
    isOptIn,
    showModal,
    clearBasket,
    disabled,
    variants,
    basket,
    itinerary,
    passengers,
    setShowOnClosePopUp,
  } = props;

  const { test_seatmap_on_exit_modal = false } = variants;

  const enableOnClosePopup = false;

  const handleCloseClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (process.env.STORYBOOK_USED) {
      return;
    }

    e.preventDefault();
    if (test_seatmap_on_exit_modal) {
      if (
        enableOnClosePopup &&
        notAllSegmentsHaveSeats(basket, itinerary, passengers)
      ) {
        setShowOnClosePopUp({
          show: true,
          trigger: 'ON_EXIT',
          opt_in: isOptIn,
        });
        return;
      }
    }
    if (isOptIn) {
      showModal(false);
    } else {
      if (typeof clearBasket === 'function') {
        clearBasket();
      }
    }
  };

  return (
    <button
      id="modal-close-button"
      aria-label="Close and skip seat selection"
      className="gr-cursor-pointer gr-h-full gr-pl-3 gr-pr-3 gordian-close-button"
      tabIndex={0}
      disabled={disabled}
      onClick={handleCloseClick}
      style={{ margin: 'auto 0', zIndex: 101 }}
    >
      <Close style={{ width: 14, height: 14 }} />
    </button>
  );
};

export default connector(CloseButton);
